export default __webpack_public_path__ + "static/media/14.7ef06a93.jpg";